import { useState } from "react";
import api from "../api";

export default function BookingModal({ isOpen, onClose, appartement, startDate, endDate, dates }) {
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [telephone, setTelephone] = useState("")
  const [email, setEmail] = useState("")

  if (!isOpen || !appartement) return null;

  // 🔢 Calcul nuits
  const nights = () => {
    if (!dates?.dateDebut || !dates?.dateFin) return 0;
    const d1 = new Date(dates.dateDebut);
    const d2 = new Date(dates.dateFin);
    return Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24));
  };

  // 💰 Calcul total
  const total = () => {
    return nights() * (appartement.prix_nuitee || 0);
  };

  const isValid = () => {
    return nom && prenom && telephone && email && nights() > 0;
  };

  const handleBooking = async () => {
    if (!isValid()) return;

    setLoading(true);

    console.log("DATES ENVOYÉES:", dates);

    try {
      const res = await api.post("/public/payment/init", {
        nom,
        prenom,
        telephone,
        email,
        appartement_id: appartement.id,
        date_debut: dates.dateDebut,
        date_fin: dates.dateFin,
        amount: total(),
        transaction_id: "tx_" + Date.now()
      });

      window.location.href = res.data.payment_url;

    } catch (err) {
      console.error(err);
      alert("Erreur paiement");
    }

    setLoading(false);

    if (!dates?.dateDebut || !dates?.dateFin) {
      alert("Dates manquantes");
      return;
}
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 animate-fade-in">

        {!success ? (
          <>
            <h2 className="text-xl font-bold mb-4">

              Réserver{" "}

              {appartement.type_logement === "chambre"
                ? "la chambre"
                : appartement.type_logement === "suite"
                ? "la suite"
                : "l'appartement"}{" "}

              {appartement.numero}

            </h2>

            {/* 📊 RÉCAP */}
            <div className="bg-gray-50 p-3 rounded-lg mb-4 text-sm">
              <p className="text-gray-500">
                {dates.dateDebut} → {dates.dateFin}
              </p>

              <div className="mt-2 border-t pt-2">
                <div className="flex justify-between">
                  <span>
                    {appartement.prix_nuitee}$ × {nights()} nuits
                  </span>
                  <span>{total()}$</span>
                </div>

                <div className="flex justify-between font-bold mt-2 text-green-600">
                  <span>Total</span>
                  <span>{total()}$</span>
                </div>
              </div>
            </div>

            {/* ⚠️ message si erreur */}
            {nights() <= 0 && (
              <p className="text-red-500 text-sm mb-2">
                Dates invalides
              </p>
            )}

            {/* INPUTS */}
            <input
              placeholder="Nom"
              className="border p-2 rounded w-full mb-3"
              value={nom}
              onChange={e => setNom(e.target.value)}
            />

            <input
              placeholder="Prénom"
              className="border p-2 rounded w-full mb-4"
              value={prenom}
              onChange={e => setPrenom(e.target.value)}
            />

            <input
              placeholder="Téléphone (+243...)"
              className="border p-2 rounded w-full mb-3"
              onChange={e => setTelephone(e.target.value)}
            />

            <input
              placeholder="Email"
              className="border p-2 rounded w-full mb-3"
              onChange={e => setEmail(e.target.value)}
            />

            {/* BOUTON */}
            <button
              disabled={!isValid() || loading}
              onClick={handleBooking}
              className={`w-full py-2 rounded-lg text-white ${
                !isValid()
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-green-500 hover:bg-green-600"
              }`}
            >
              {loading ? "Réservation..." : "Confirmer"}
            </button>

            <button
              onClick={onClose}
              className="mt-3 w-full text-gray-500"
            >
              Annuler
            </button>
          </>
        ) : (
          <div className="text-center">
            <h2 className="text-xl font-bold text-green-600 mb-2">
              ✅ Réservation confirmée !
            </h2>

            <p className="text-gray-500 mb-4">
              Merci {prenom}, votre séjour est enregistré.
            </p>

            <button
              onClick={() => {
                setSuccess(false);
                setNom("");
                setPrenom("");
                onClose();
              }}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Fermer
            </button>
          </div>
        )}

      </div>
    </div>
  );
}